import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { EFProduct, EFSupplier } from 'pg-lib/models/experience.model';
import { AnalyticsService } from 'pg-lib/services/analytics.service';
import { EFDataService } from 'pg-lib/services/ef-data.service';
import { PGUtilities } from 'pg-lib/utilities/pg-utilities';
import { TotemWidget, TotemWidgetProductsFilter } from '../totem-widget';

export class TotemWidgetClustersItem {
    label:string
    title?:string
    description?:string
    video?:string
    videoPoster?:string
    icon:string
    image:string
    color:string
    filter?:TotemWidgetProductsFilter
    cover?:string
}

@Component({
    selector: 'app-totem-widget-clusters',
    templateUrl: './totem-widget-clusters.component.html',
    styleUrls: ['./totem-widget-clusters.component.scss'],
    standalone: false
})
export class TotemWidgetClustersComponent extends TotemWidget implements OnChanges {

    constructor(public elementRef:ElementRef, private efDataService:EFDataService, private analyticsService:AnalyticsService) {
        super(elementRef)
    }

    size:'lg' = 'lg'

    @Input() title:string
    @Input() subtitle:string
    @Input() clusters:Array<TotemWidgetClustersItem>
    @Input() productsData:Array<EFProduct>

    selectedCluster:TotemWidgetClustersItem = null
    filteredData:Array<EFProduct> = null;

    ngOnChanges() {
        this._updateSelectedCluster()
    }

    private _updateSelectedCluster() {
        this.selectedCluster = null
        this.filteredData = null
        this.selectedProductId = null;
        this.selectedProductData = null;
        this.selectedProductSupplierData = null;

        if(this.fullScreen && this.clusters != null) {
            let _index = this._getClusterIndex()

            if(_index != null && this.clusters[_index] != null) {
                this.selectedCluster = this.clusters[_index]
                this.filteredData = this.applyProductsFilter(this.productsData, this.selectedCluster.filter)
            }
        }

    }

    private _getClusterIndex():number {
        if(this.fullScreenParams == null || this.fullScreenParams === '') return null
        if(typeof this.fullScreenParams == 'number') return this.fullScreenParams

        let _index = parseInt(String(this.fullScreenParams), 10)
        return isNaN(_index) ? null : _index
    }

    onClusterClick(cluster:TotemWidgetClustersItem) {
        let _index = this.clusters.indexOf(cluster)
        let _params = _index.toString()

        if(this.clusters[_index].label) {
            _params += '_' + PGUtilities.cleanSlug(this.clusters[_index].label)
        }

        this.requestFullScreen.emit({ params: _params })
    }

    getIconClass(icon:string) {
        if(icon == null || icon === '') return 'fa-regular fa-circle'
        if(/\bfa-(solid|regular|light|thin|duotone|brands)\b/.test(icon)) return icon
        return 'fa-regular ' + icon
    }

    hasImage(cluster:TotemWidgetClustersItem) {
        return cluster?.image != null && cluster.image !== '' && /^https?:\/\//.test(cluster.image)
    }

    hasClusterHeader(cluster:TotemWidgetClustersItem) {
        return (cluster?.title != null && cluster.title !== '')
            || (cluster?.cover != null && cluster.cover !== '')
            || (cluster?.description != null && cluster.description !== '')
            || (cluster?.video != null && cluster.video !== '')
    }

    reverseArray(array:Array<any>) {
        if(array != null) {
            return [...array].reverse()
        }
    }

    selectedProductId:string = null;

    selectedProductData:EFProduct = null;
    selectedProductSupplierData:EFSupplier = null;

    isLoadingProduct = false;

    onShowProduct(product:string) {
        this.selectedProductId = product;

        this.isLoadingProduct = true;

        this.efDataService.getProductDetail(this.selectedProductId).subscribe((data) => {

            this.selectedProductData = data;

            if(data?.analytics != null) {
                this.analyticsService.sendEvent('showProduct', data.analytics)
            }

            if(this.selectedProductData != null && this.selectedProductData.supplier != null) {
                let _supplierSplit = this.selectedProductData.supplier.split('_');

                this.efDataService.getResourceSupplier(_supplierSplit[0], _supplierSplit[1]).subscribe((data) => {
                    this.selectedProductSupplierData = data;
                    this.isLoadingProduct = false;
                })
            }
            else {
                this.isLoadingProduct = false;
            }
        })
    }
}
